import i18n from 'i18n'
import * as React from 'react'
import { useState, useEffect } from 'react'
import { 
    IconButtonSeeker, 
    useToaster
} from 'ui-seeker/core'
import { postSubmit } from 'ui-seeker/utils'

import { useCommonFilters } from 'app/components'
import { ALERTS } from 'app/@common/constants'
import { AppTooltip } from 'app/@components'


export default function ExcelBtn() {

    const [loading, setLoading] = useState(false)
    const [submit, setSubmit] = useState(false)
    const { showToaster } = useToaster()
    const { dataFilters } = useCommonFilters()

	const downloadFile = fileUrl => {
		const link = document.createElement('a')
		link.href = fileUrl
		link.download = fileUrl
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}

    const getData = () => {
        setLoading(true)
        showToaster.info(i18n.t('common:excel.pleaseWait'))        

        postSubmit(ALERTS.EXPORT, { ...dataFilters }).then(res => {
            showToaster.success(i18n.t('common:excel.downloading'))
            downloadFile(res.storage_url)
        }).catch(() => {
            showToaster.error(i18n.t('common:excel.errorProcessing'))
        }).finally(() => {
            setLoading(false)
            setSubmit(false)
        })
    }

    useEffect(() => {
        if (submit) getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submit])

    return <>
        <AppTooltip
            title={i18n.t('common:excel.exportToExcel')}
        >
            <IconButtonSeeker
                icon="file-excel"
                iconType="fontAwesome"
                className="icon-filter-excel-custom"
                onClick={() => setSubmit(true)}
            />
        </AppTooltip>
    </>
}